<template>
  <div class="storeage-management-root">
    <div id="storageBox"></div>
    <div class="dataTable" v-loading="loading" v-show="!isStorageListShow">
      <el-table :data="tableData" height="100%">
        <el-table-column prop="app_name" label="应用名称" width="190" />
        <el-table-column prop="platform" label="所属平台" width="80" />
        <el-table-column prop="lan_size" label="内网容量">
          <template v-slot="scope">
            <el-link
              :underline="false"
              type="primary"
              @click="storageSelect(scope, '内网')"
            >
              {{ scope.row.lan_size }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="wan_size" label="外网容量">
          <template v-slot="scope">
            <el-link
              :underline="false"
              type="primary"
              @click="storageSelect(scope, '外网')"
            >
              {{ scope.row.wan_size }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="total_size" label="总容量" />
      </el-table>
    </div>
    <div class="dataTable" v-show="isStorageListShow">
      <el-form label-width="100px">
        <el-link
          class="returncss"
          type="primary"
          :underline="false"
          @click="backList"
        >
          返回列表
        </el-link>
        <el-form-item label="应用名称：">
          <span>{{ storageDetail.appName }}</span>
        </el-form-item>
        <el-form-item label="所在网络：">
          <span>{{ storageDetail.net }}</span>
        </el-form-item>
        <el-form-item label="存储容量：">
          <span>{{ storageDetail.storage }}</span>
        </el-form-item>
      </el-form>
      <hr />
      <div class="datePicker">
        <el-date-picker
          style="width: 250px; flex-grow: 0"
          size="large"
          v-model="dateRange"
          type="daterange"
          unlink-panels
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          :shortcuts="shortcuts"
        />
        <el-select
          style="width: 120px"
          v-model="dataTag"
          class="m-2"
          placeholder="请选择"
          size="large"
        >
          <el-option label="全部" value="" />
          <el-option label="有标签" value="true" />
          <el-option label="无标签" value="false" />
        </el-select>
        <el-button type="primary" size="large" @click="appDataSelect">
          查询
        </el-button>
        <el-button
          type="danger"
          size="large"
          @click="appDataDelete"
          :disabled="selectedData.length == 0"
          style="margin: 0"
        >
          删除
        </el-button>
      </div>
      <div class="dataList">
        <el-table
          ref="multipleTableRef"
          :data="dataList"
          height="100%"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          empty-text="暂无数据"
          v-loading="isDataListLoad"
        >
          <el-table-column type="selection" width="40" />
          <el-table-column label="创建时间" width="150">
            <template #default="scope">{{
              formatDateTime(scope.row.createtime)
            }}</template>
          </el-table-column>
          <el-table-column label="文件大小">
            <template #default="scope">{{
              getfilesize(scope.row.package.size)
            }}</template>
          </el-table-column>
          <el-table-column label="存储" width="90">
            <template #default="scope">
              <span
                v-if="
                  scope.row.package.lanurl != '' &&
                  scope.row.lan_storage_status === 'LanNormal'
                "
              >
                内网
              </span>
              <span
                v-if="
                  scope.row.package.url != '' &&
                  scope.row.wan_storage_status === 'WanNormal'
                "
              >
                云端
              </span>
            </template>
          </el-table-column>
          <el-table-column label="标签">
            <template #default="scope">
              <el-tag
                v-for="item in scope.row.tags"
                :key="item"
                :type="item"
                size="mini"
              >
                {{ item }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="版本号">
            <template #default="scope">
              <span>{{ scope.row.package.version }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  apiGetStorageData,
  apiGetVersionSerch,
  apiGetStorageDelete,
} from "@/Api/AppApi";
import { formatDateTime } from "@/Utils/UtilTools";
import { storeToRefs } from "pinia";
import { useProjectStore } from "@/Store/ProjectStore";
import { ElMessage, ElMessageBox } from "element-plus";
import { onBeforeUnmount, reactive, toRaw, watch, ref } from "vue";
import * as echarts from "echarts";

onBeforeUnmount(() => {
  if (myChart) {
    myChart.dispose();
    myChart = null;
  }
});

const projectStore = useProjectStore();
const { currentProjectId } = storeToRefs(projectStore);
let tableData = reactive([]);
let loading = ref(false);
let isStorageListShow = ref(false);
let isDataListLoad = ref(false);
let tempData = [];
let dataList = reactive([]);
let endTime = new Date();
let startTime = new Date(endTime.getTime() - 2592000000 * 24);
let dateRange = ref([startTime, endTime]);
let dataTag = ref("");
let selectedData = reactive([]);
let storageDetail = reactive({
  appName: "",
  net: "",
  storage: "",
  appid: "",
});
const shortcuts = [
  {
    text: "最近一周",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      return [start, end];
    },
  },
  {
    text: "最近一个月",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      return [start, end];
    },
  },
  {
    text: "最近三个月",
    value: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      return [start, end];
    },
  },
];

function getfilesize(size) {
  if (!size) return "0";
  let num = 1024.0; //byte
  if (size < num) return size + "B";
  if (size < Math.pow(num, 2)) return (size / num).toFixed(2) + "K"; //kb
  if (size < Math.pow(num, 3))
    return (size / Math.pow(num, 2)).toFixed(2) + "M"; //M
  if (size < Math.pow(num, 4))
    return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
  return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
}

function storageSelect(rowData, type) {
  isStorageListShow.value = true;
  storageDetail.appName = rowData.row.app_name;
  storageDetail.appid = rowData.row.appid;
  storageDetail.net = type;
  type == "外网"
    ? (storageDetail.storage = rowData.row.wan_size)
    : (storageDetail.storage = rowData.row.lan_size);
}

async function getStorageData() {
  loading.value = true;
  tableData.splice(0);
  let projectId = toRaw(currentProjectId.value);
  const res = await apiGetStorageData(projectId);
  tempData = JSON.parse(JSON.stringify(res.data));
  tableData.push(...tempData);
  getStorageChart(tempData);
  tableData.sort((a, b) => {
    return b.total_size - a.total_size;
  });
  tableData.forEach((element) => {
    element.total_size = getfilesize(element.total_size);
    element.wan_size = getfilesize(element.wan_size);
    element.lan_size = getfilesize(element.lan_size);
  });
  loading.value = false;
}
function appDataDelete() {
  ElMessageBox.confirm("此操作将永久删除该文件, 是否继续?", "Warning", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      let deleteData = {
        net: toRaw(storageDetail.net) == "内网" ? "lan" : "wan",
        versionids: toRaw(selectedData),
      };
      apiGetStorageDelete(deleteData).then(() => {
        appDataSelect();
      });
      ElMessage({
        type: "success",
        message: "删除成功",
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
}
function handleSelectionChange(row) {
  selectedData.splice(0);
  let versionidsList = [];
  row.forEach((item) => {
    versionidsList.push(item.id);
  });
  selectedData.push(...versionidsList);
}
async function appDataSelect() {
  if (dateRange.value === null) {
    ElMessage({
      type: "error",
      message: "请选择时间范围",
    });
    return;
  }
  isDataListLoad.value = true;
  dataList.splice(0);
  const rowdata = {
    appid: storageDetail.appid,
    et:
      formatDateTime(toRaw(dateRange.value[1])).replace(" ", "T") + ":00+08:00",
    net: storageDetail.net == "内网" ? "lan" : "wan",
    st:
      formatDateTime(toRaw(dateRange.value[0])).replace(" ", "T") + ":00+08:00",
    tag: toRaw(dataTag.value),
  };
  let res = await apiGetVersionSerch(rowdata);
  dataList.push(...res.data);
  isDataListLoad.value = false;
}
function backList() {
  isStorageListShow.value = false;
  dataList.splice(0);
}

let myChart = null;
// echarts绘制存储图
function getStorageChart(diskData) {
  if (myChart === null) {
    let chartDom = document.getElementById("storageBox");
    myChart = echarts.init(chartDom);
    myChart.on("click", (param) => {
      let appid;
      dataList.splice(0);
      tableData.forEach((item) => {
        if (item.app_name == param.treeAncestors[1].name) {
          appid = item.appid;
        }
      });
      const rowdata = {
        row: {
          appid,
          app_name: param.treeAncestors[1].name,
          wan_size: getfilesize(param.treeAncestors[2].value),
          lan_size: getfilesize(param.treeAncestors[2].value),
        },
      };
      storageSelect(rowdata, param.name);
    });
  }

  let formatUtil = echarts.format;
  let data = [];

  diskData.forEach((item) => {
    data.push({
      name: item.app_name,
      value: item.total_size,
      children: [
        {
          name: "内网",
          value: item.lan_size,
        },
        {
          name: "外网",
          value: item.wan_size,
        },
      ],
    });
  });
  let option = {
    tooltip: {
      formatter: function (info) {
        let value = getfilesize(info.value);
        let treePathInfo = info.treePathInfo;
        let treePath = [];
        for (let i = 1; i < treePathInfo.length; i++) {
          treePath.push(treePathInfo[i].name);
        }
        return [
          '<div class="tooltip-title">应用名称：' +
            formatUtil.encodeHTML(treePath.join(" / ")) +
            "</div>",
          "存储容量：" + value,
        ].join("");
      },
    },
    legend: {
      show: false,
    },
    series: [
      {
        name: "应用列表",
        breadcrumb: { show: false },
        type: "treemap",
        nodeClick: false,
        roam: true,
        data,
        visibleMin: 300,
        label: {
          show: true,
          formatter: function (info) {
            let str = "";
            return str.concat(info.name);
          },
        },
        upperLabel: {
          show: true,
          height: 20,
          color: "#333",
          fontSize: 12,
          padding: [0, 0, 0, 0],
        },
        emphasis: {
          upperLabel: {
            show: true,
            color: "#333",
            fontSize: 12,
          },
        },
        itemStyle: {
          borderColor: "#fff",
        },
        levels: [
          {
            itemStyle: {
              borderColor: "#555",
              borderWidth: 4,
              gapWidth: 4,
            },
          },
          {
            colorSaturation: [0.3, 0.6],
            itemStyle: {
              borderColorSaturation: 0.7,
              gapWidth: 2,
              borderWidth: 2,
            },
          },
          {
            colorSaturation: [0.3, 0.5],
            itemStyle: {
              borderColorSaturation: 0.6,
              gapWidth: 1,
            },
          },
          {
            colorSaturation: [0.3, 0.5],
          },
        ],
      },
    ],
  };
  option && myChart.setOption(option);
}

watch(
  currentProjectId,
  (val) => {
    if (val) {
      getStorageData();
    }
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.storeage-management-root {
  padding: 20px;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dataTable {
  height: 100%;
  width: 34%;
  background-color: #fff;
  box-shadow: 3px 3px 8px #bdbcbc;
  padding: 15px 20px 0;
}
#storageBox {
  height: 100%;
  width: 66%;
}
.el-form-item {
  margin-bottom: 0px;
}
.returncss {
  position: absolute;
  margin-top: 8px;
  right: 40px;
  z-index: 10;
}

.datePicker {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.dataList {
  height: calc(100% - 174px);
}
</style>
